<template>
    <v-row align="center" justify="center">
        <v-col cols="12" class="mb-0">
            <v-card class="elevation-1">
                <v-card-title>
                    <v-toolbar flat>
                        <v-btn small dark color="primary" @click="dialog = true">
                            <v-icon left>fas fa-plus-square</v-icon>Registrar pago
                        </v-btn>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <SingleCalendar refElement="activeInicio" :input-date.sync="datesRange.start"
                            title="Fecha inicio" />
                        <SingleCalendar refElement="activeFin" :input-date.sync="datesRange.end" title="Fecha fin" />
                        <v-divider class="mx-2" inset vertical></v-divider>
                    </v-toolbar>
                    <v-col cols="12" md="6" sm="12"></v-col>
                    <v-col cols="12" md="6" sm="12" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search"
                            label="Buscar registros de pago" single-inline hide-details
                            placeholder="Buscar por razonSocial, folio, numero de operación"
                            @keydown.enter="searchPago">
                        </v-text-field>
                        <v-btn icon class="mt-4 ml-2">
                            <v-icon dense>fas fa-sync</v-icon>
                        </v-btn>
                        <v-tooltip left color="success">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon class="mt-4 ml-2" color="success" v-bind="attrs" v-on="on" dark
                                    @click="handleExcelExport">
                                    <v-icon dark left>fas fa-file-pdf</v-icon>
                                </v-btn>
                            </template>
                            <span>Reporte de pagos</span>
                        </v-tooltip>
                        <Columns :headers.sync="headers"></Columns>
                    </v-col>
                </v-card-title>
                <v-card-text>
                    <v-data-table dense :headers="filteredHeaders" :items="listaPago" class="elevation-2" :loading="loading"
                        loading-text="Cargando... espera un momento" :options.sync="options" :footer-props="{ 'items-per-page-options': [ 25, 50, 100 ],
                        showFirstLastPage: true,
                        firstIcon: 'fas fa-angle-double-left',
                        lastIcon: 'fas fa-angle-double-right',
                        prevIcon: 'fas fa-angle-left',
                        nextIcon: 'fas fa-angle-right'
                    }" :server-items-length="totalListaPago">
                        <template v-slot:[`item.actions`] ="{ item }">
                            <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                        <v-icon>fas fa-ellipsis-v</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click.prevent="showDetail(item)">
                                        <v-list-item-title>
                                            <v-icon small class="mr-2">fas fa-clipboard-list</v-icon> Detalle del pago
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.prevent="showEvidences(item.id)">
                                        <v-list-item-title>
                                            <v-icon small class="mr-2">fa-solid fa-folder-open</v-icon> Ficheros/Evidencias
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.prevent="removePago({ pago: item })" v-if="!item.eliminado && isAdmin">
                                        <v-list-item-title class="bg-red darken-4">
                                            <v-icon small class="mr-2">fas fa-trash-alt</v-icon> Cancelar pago
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                        <template v-slot:[`item.status`] ="{ item }">
                            <v-chip filter label :color="item.eliminado ? 'red' : 'green'" dark
                            class="ma-2" text-color="white">
                                {{ item.eliminado ? 'Cancelado' : 'Activo' }}
                            </v-chip>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
        <NuevoPago :dialog="dialog" :handleModal="handleModal"
        :clients.sync="clients"
        :initialize.sync="initTablePago" v-if="dialog"/>
        
        <DetailPayment :dialog="dialogDetail" :handleModal="handleModalDetail" :pago="pago" v-if="dialogDetail"/>
        
        <ExcelExporterPago :dialog="dialogExcelExport" :handleModal="handleModalExcelExport"
        :clients.sync="clients"
        v-if="dialogExcelExport"/>
        <ViewFilesTable :lstFiles="lstEvidences" :dialog="dialogEvidences"
        title-files="Ficheros y evidencias de pagos de venta"
        v-if="dialogEvidences && lstEvidences.length > 0" :handleDialogFiles="handleDialogFiles">
        </ViewFilesTable>
    </v-row>
</template>
<script>
import VentaPagoDataService from '@/service/venta/pago/VentaPagoDataService';
import ClienteDataService from '@/service/cliente/clienteDataService';
import { getParamsPagination } from '@/utils/pagination';
import SingleCalendar from '@/components/shared/SingleCalendar.vue';
import NuevoPago from './NuevoPago.vue';
import DetailPayment from './DetailPayment.vue';
import ExcelExporterPago from './ExcelExporterPago.vue';
import Columns from '@/components/shared/Columns.vue';
import Camera from '@/assets/camera.png';
import VentaPagoEvidenceFileService from '@/service/venta/evidences/VentaPagoEvidenceFileService';
import ViewFilesTable from '@/components/shared/ViewFilesTable.vue';
import UsuarioDataService from '@/service/usuario/UsuarioDataService';

export default {
    name: "ListaPago",
    components: { SingleCalendar, NuevoPago, DetailPayment, ExcelExporterPago, Columns, ViewFilesTable },
    created() {
        this.getClients();
    },
    data() {
        return {
            clients: [],
            listaPago: [],
            datesRange: {
                start: null,
                end: null
            },
            options: {},
            totalListaPago: 0,
            loading: true,
            search: '',
            headers: [
                { text: 'Acciones', value: 'actions', sortable: false, groupable: false, show: true },
                { text: 'Folio de pago', value: 'folio', groupable: false, show: true },
                { text: 'Cliente', value: 'client.razonSocial', groupable: false, show: true },
                { text: 'Fecha de pago', value: 'paymentDateNatural', groupable: false, show: true },
                { text: 'Monto pagado', value: 'payedAmountNatural', groupable: false, show: true },
                { text: 'Forma de pago', value: 'paymentMethodNatural', groupable: false, show: true },
                { text: 'Folio de operación', value: 'operationNumber', groupable: false, show: true },
                { text: 'Estatus', value: 'status', sortable: false, groupable: false, show: true },
                { text: 'Registrado por', value: 'registeredBy', groupable: false, show: true },
                { text: 'Creado por', value: 'createdBy', groupable: false, show: false },
            ],
            dialog: false,
            dialogDetail: false,
            dialogExcelExport: false,
            // To evidence.
            dialogEvidences: false,
            lstEvidences: [],
        }
    },
    methods: {
        searchPago(){
            this.options.page = 1;
            this.initTablePago(this.options);
        },
        initTablePago( options = {} ){
            this.loading = true;
            const params = getParamsPagination({ options, search: this.search,
                params: { startDate: this.datesRange.start, endDate: this.datesRange.end }
            });
            VentaPagoDataService.table( params ).then( resp => {
                const { rows, totalElements } = resp.data;
                this.listaPago = rows;
                this.totalListaPago = totalElements;
            }).catch( err => {
                this.$swal.fire({ icon: 'error', title: 'Falló la carga de información', html: err.response.data, timer: 5000 });
            }).finally( () => {
                this.loading = false;
            });
        },
        handleExcelExport(){ this.dialogExcelExport = !this.dialogExcelExport },
        getClients(){
            ClienteDataService.getAll().then( resp => {
                this.clients = resp.data;
            })
        },
        showDetail( pago ){
            this.pago = pago;
            this.dialogDetail = true;
        },
        handleModal(){ this.dialog = !this.dialog; },
        handleModalDetail(){ this.dialogDetail = !this.dialogDetail; },
        handleModalExcelExport(){ this.dialogExcelExport = !this.dialogExcelExport; },
        showEvidences(paymentProviderId){
            this.dialogEvidences = true
            this.getListEvidences(paymentProviderId)
        },
        removePago({ pago }) {
            const { id, operationNumber, paymentMethodNatural, paymentDateNatural, payedAmountNatural, folio } = pago;
            this.$swal.fire({
                title: `Estas seguro que deseas cancelar el pago \n Folio: ${folio} ? \n Referencia: ${operationNumber} \n Forma de pago: ${paymentMethodNatural} \n Fecha de pago: ${paymentDateNatural} \n Monto pagado: ${payedAmountNatural}`,
                text: "Esta accion no se podra revertir!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, cancelar!",
                cancelButtonText: "No"
            }).then(result => {
                if (result.isConfirmed) {
                    VentaPagoDataService.cancelPayment(id).then(resp => {
                        this.$swal.fire({ icon: 'success', title: 'Pago cancelado', text: 'El pago ha sido cancelado', showConfirmButton: false, timer: 3000 });
                        this.initTablePago();
                    }).catch(err => {
                        this.$swal.fire({ icon: 'error', title: 'Error al cancelar el pago', html: err?.response?.data, showConfirmButton: false, timer: 3500 });
                    })
                }
            }).catch(err => {
                this.$swal.fire({ icon: 'error', title: 'Error al cancelar el pago', html: err?.response?.data, showConfirmButton: false, timer: 3500 });
            });
        },
        getListEvidences(ventaPagoId){
            let params = { page: 0, size: 25 };
            this.lstEvidences = [];
            VentaPagoEvidenceFileService.table( params, ventaPagoId ).then( response => {
                let evidences = response.data.rows.map(evidence => {
                    return {
                        ...evidence,
                        typeFile: evidence.type.startsWith('image') ? 'image' : 'pdf',
                        url: evidence.name != null ? `${this.$store.state.auth.rutaFichero}ventaPagoEvidences/${evidence.name}` : Camera
                    };
                });
                this.lstEvidences = evidences;
                if(this.lstEvidences.length === 0) this.$swal.fire({ icon: 'info', html: 'No se encontraron evidencias', showConfirmButton: false, timer: 3500 });
            }).catch(err => {
                this.$swal.fire({ position: 'top-end', icon: 'error', html: 'Error al cargar las evidencias' + err.response.data, showConfirmButton: false, timer: 3500 });
            })
        },
        handleDialogFiles() { this.dialogEvidences = !this.dialogEvidences }
    },
    watch: {
        options: {
            handler( val, oldVal ) {
                if (val.page !== oldVal.page || val.itemsPerPage !== oldVal.itemsPerPage) {
                    this.initTablePago(val);
                }
            }, deep: true
        },
        'datesRange.start': function( val, oldVal ) {
            if (val !== oldVal && this.datesRange.end != null && this.datesRange.end != '') {
                this.initTablePago(this.options);
            }
        },
        'datesRange.end': function( val, oldVal ) {
            if (val !== oldVal && this.datesRange.start != null && this.datesRange.start != '') {
                this.initTablePago(this.options);
            }
        }
    },
    computed: {
        isAdmin(){ return UsuarioDataService.getUserRoles().includes('ROLE_ADMIN'); },
        filteredHeaders(){ return this.headers.filter( header => header.show ); }
    }
}
</script>